import { Box, Tooltip } from '@mui/material';

export function LearningBudgetSetupItemDirtyDot({
  isDirty,
}: {
  isDirty: boolean;
}) {
  if (!isDirty) return null;

  return (
    <Tooltip title="This LB amount has been updated.">
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: 'info.dark',
          ml: 1,
        }}
      />
    </Tooltip>
  );
}
